import { DEFAULT_LOCALE } from '../consts/consts';

const PERCENTAGE_DIVIDER = 100;

export const DEFAULT_PERCENTAGE_DECIMAL_PLACES = 3;

export const formatPercentage = (
	percentage: number = NaN,
	{
		locale = DEFAULT_LOCALE,
		negative = false,
		maximumFractionDigits = DEFAULT_PERCENTAGE_DECIMAL_PLACES,
	}: { locale?: string; negative?: boolean; maximumFractionDigits?: number } = {}
) => {
	const value = (negative ? -percentage : percentage) / PERCENTAGE_DIVIDER;
	return Intl.NumberFormat(locale, {
		style: 'percent',
		maximumFractionDigits,
	}).format(value);
};
